const estadosInvStr = {}

function convertEIntToEString (eInt) {
  let eStr
  switch (eInt) {
    case '1':
      // eStr = 'Sin Emplazar'
      eStr = 'NUEVO'
      break
    case '2':
      eStr = 'DAÑADO'
      break
    default:
      eStr = 'N/A'
      break
  }
  console.log(eStr)
  return eStr
}

estadosInvStr.install = function (Vue) {
  Vue.filter('estadosInv', (val) => {
    return convertEIntToEString(val)
  })
}

export default estadosInvStr



// WEBPACK FOOTER //
// ./src/filters/estadosInventario.js